import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  T_MFDashboardDetails,
  T_MutualFundSliceState,
} from "./MutualFund_Types";
import { T_BackgroundImage } from "../../globalTypes/GlobalTypes";

const initialState: T_MutualFundSliceState = {
  mfDashboardDetails: {
    INVESTED_AMOUNT: null,
    CURRENT_VALUE: null,
    XIRR_VALUE: null,
    IS_XIRR_VALUE_VISIBLE: false,
  },
  folioDetails: [],
  secondaryFolioDetails: [],
  folioSchemeDetails: [],
  serviceMenuDetails: [],
  maskDetailsPageValues: false,
  backgroundImages: [],
};

export const MutualFundSlice = createSlice({
  name: "MutualFundSlice",
  initialState,
  reducers: {
    setMfDashboardDetails: (state, action) => {
      return {
        ...state,
        mfDashboardDetails: { ...state.mfDashboardDetails, ...action.payload },
      };
    },
    setFolioDetails: (state, action) => {
      return {
        ...state,
        folioDetails: action.payload,
      };
    },
    setSecondaryFolioDetails: (state, action) => {
      return {
        ...state,
        secondaryFolioDetails: action.payload,
      };
    },
    updateSecondaryFolioValues: (
      state,
      action: PayloadAction<{ pan: string; values: T_MFDashboardDetails }>,
    ) => {
      const { pan, values } = action.payload;
      const folio = state.secondaryFolioDetails.find((f) => f.pan === pan);
      if (folio) {
        folio.values = values;
      }
    },
    setServiceMenuMFDetailsList: (state, action) => {
      return {
        ...state,
        serviceMenuDetails: action.payload,
      };
    },
    setFolioSchemeDetails: (state, action) => {
      return {
        ...state,
        folioSchemeDetails: action.payload,
      };
    },
    setXirrVisibility: (state, action) => {
      return {
        ...state,
        mfDashboardDetails: {
          ...state.mfDashboardDetails,
          IS_XIRR_VALUE_VISIBLE: action.payload,
        },
      };
    },
    setMaskDetailsPageValues: (state, action) => {
      return {
        ...state,
        maskDetailsPageValues: action.payload,
      };
    },
    setMfBackgroundImage: (state, action: PayloadAction<T_BackgroundImage>) => {
      const existingBackgroundImages = Array.isArray(state.backgroundImages)
        ? state.backgroundImages
        : [];

      return {
        ...state,
        backgroundImages: [...existingBackgroundImages, action.payload],
      };
    },
  },
});

export const MutualFundReducer = MutualFundSlice.reducer;
export const MutualFundSliceKey = MutualFundSlice.reducerPath;

export const {
  setMfDashboardDetails,
  setFolioDetails,
  setFolioSchemeDetails,
  setServiceMenuMFDetailsList,
  setSecondaryFolioDetails,
  updateSecondaryFolioValues,
  setXirrVisibility,
  setMfBackgroundImage,
  setMaskDetailsPageValues,
} = MutualFundSlice.actions;
